import React, { useEffect } from 'react';
import { LoadingSpinner } from '@carvana/core-helios-loader';
import styles from './loading-screen.module.css';

export const LoadingScreen = () => {
  useEffect(() => {
    const modalContent = document.getElementById('modal-content');
    if (modalContent) {
      modalContent.style.height = '100%';
    }

    return () => {
      if (modalContent) {
        modalContent.style.height = '';
      }
    };
  }, []);

  return (
    <div className={styles['spinner-screen']}>
      <LoadingSpinner />
      <p>Preparing your next steps...</p>
    </div>
  );
};

export default LoadingScreen;
